module.exports = __webpack_public_path__ + "img/qr_code.2c9c8f89.svg";